import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import {
  Table,
  Button,
  Glyphicon,
  FormGroup,
  FormControl
} from 'react-bootstrap';
import ReactDOM from 'react-dom';
import i18n from 'kodyl-js/i18n/react';
import {
  changeEmail,
  EMAIL_SUCCESS,
  changeName,
  CHANGENAME_SUCCESS,
  verifyEmail
} from '../../redux/modules/auth';
import Badge from '../../common/badge';
import ErrorMessage from '../../common/error-message';
import VerifyEmail from '../../common/verify-email';

function validateEmail(email) {
  return /^[^@]+@[^.]+\..{2,}$/.test(email);
}

const ERROR = 'error';
const WARNING = 'warning';
const API_CALLS = {
  editEmail: {
    method: 'changeEmail',
    type: EMAIL_SUCCESS,
    key: 'email'
  },
  editName: {
    method: 'changeName',
    type: CHANGENAME_SUCCESS,
    key: 'name'
  }
};

class ProfileTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      editEmail: false,
      editName: false,
      error: false
    };
  }

  changeVal = identifier => {
    this.setState({ error: false, lading: true });
    const val = ReactDOM.findDOMNode(this[identifier]).value;

    if (identifier === 'editEmail' && !validateEmail(val)) {
      return this.setState({ ['editEmail']: ERROR });
    }

    this.props[API_CALLS[identifier].method]({
      [API_CALLS[identifier].key]: val
    }).then(action => {
      if (action.type !== API_CALLS[identifier].type) {
        const {
          error: { response }
        } = action;
        if (
          response &&
          response.errors &&
          response.errors.email &&
          response.errors.email.message &&
          /email address is already in use/.test(response.errors.email.message)
        ) {
          this.setState({
            error: this.i18n('The specified email address is already in use'),
            editEmail: ERROR
          });
          return action;
        }

        this.setState({
          error: this.i18n(
            'Oops! Something went wrong. Please try again or reach out to our customer support.'
          ),
          loading: false,
          [identifier]: false
        });
        return action;
      }

      this.setState({ [identifier]: false });
      return action;
    });
  };

  changeContent = identifier => {
    this.setState({ [identifier]: true });
  };

  reset = identifier => {
    this.setState({ [identifier]: false });
  };

  render() {
    const { user, subscriptionsList } = this.props;
    const { editEmail, editName, error } = this.state;
    if (!user) {
      return null;
    }

    return (
      <div>
        <VerifyEmail />

        <Table responsive condensed className="profile">
          <tbody>
            <tr id="tr-name">
              <td>
                <strong>{this.i18n('Name')}</strong>
              </td>
              <td>
                {!editName ? (
                  user.name || this.i18n('Intet navn')
                ) : (
                  <FormGroup
                    validationState={editName === WARNING ? 'warning' : null}
                  >
                    <FormControl
                      type="text"
                      placeholder={this.i18n('Name')}
                      required
                      ref={ref => (this.editName = ref)}
                      defaultValue={user.name || ''}
                    />
                    <FormControl.Feedback />
                  </FormGroup>
                )}
              </td>
              <td style={{ textAlign: 'right' }}>
                {!editName ? (
                  <Button
                    onClick={() => this.changeContent('editName')}
                    bsStyle="info"
                  >
                    <Glyphicon glyph="pencil" />
                  </Button>
                ) : (
                  <div>
                    <Button
                      onClick={() => this.changeVal('editName')}
                      bsStyle="success"
                    >
                      <Glyphicon glyph="ok" />
                    </Button>
                    &nbsp;
                    <Button
                      onClick={() => this.reset('editName')}
                      bsStyle="danger"
                    >
                      <Glyphicon glyph="remove" />
                    </Button>
                  </div>
                )}
              </td>
            </tr>
            <tr id="tr-email">
              <td>
                <strong>{this.i18n('Email')}</strong>
                {!user.email ? <Badge /> : null}
              </td>
              <td>
                {!editEmail ? (
                  user.email || this.i18n('Email mangler')
                ) : (
                  <FormGroup
                    validationState={editEmail === ERROR ? 'error' : null}
                  >
                    <FormControl
                      type="email"
                      placeholder={this.i18n('Email')}
                      required
                      ref={ref => (this.editEmail = ref)}
                      defaultValue={user.email || ''}
                    />
                    <FormControl.Feedback />
                  </FormGroup>
                )}
              </td>
              <td style={{ textAlign: 'right' }}>
                {!editEmail ? (
                  <Button
                    onClick={() => this.changeContent('editEmail')}
                    bsStyle="info"
                  >
                    <Glyphicon glyph="pencil" />
                  </Button>
                ) : (
                  <div>
                    <Button
                      onClick={() => this.changeVal('editEmail')}
                      bsStyle="success"
                    >
                      <Glyphicon glyph="ok" />
                    </Button>
                    &nbsp;
                    <Button
                      onClick={() => this.reset('editEmail')}
                      bsStyle="danger"
                    >
                      <Glyphicon glyph="remove" />
                    </Button>
                  </div>
                )}
              </td>
            </tr>
            {subscriptionsList.map((s, idx) => {
              if (!idx) {
                return (
                  <tr key={idx}>
                    <td>
                      <strong>{this.i18n('Subscription')}</strong>
                    </td>
                    <td colSpan={2}>
                      <Link to="/profile/subscription">
                        {s.product.label} ({s.product.price})
                      </Link>
                    </td>
                  </tr>
                );
              }
              return (
                <tr key={idx}>
                  <td />
                  <td>{s.label}</td>
                  <td />
                </tr>
              );
            })}
          </tbody>
        </Table>
        {error ? <ErrorMessage text={error} /> : null}
      </div>
    );
  }
}

export default connect(
  ({ auth: { user }, subscriptions: { list } }) => ({
    user,
    subscriptionsList: list
  }),
  { changeEmail, changeName, verifyEmail }
)(i18n(ProfileTab));
